import axios from 'axios';
import CONFIG from '../config';

export const getGeneralContent = (slug) => axios.get(`${CONFIG.API_BASE}/xapi/content/get/default/${slug}`).then(res => res.data);
